import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import green from '@material-ui/core/colors/green'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    container: {
        minHeight: '90vh',
        padding: theme.spacing(1),
    },
    root: {
        minWidth: 275,
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(4),
        padding: 0,
    },
    card: {
        marginTop: theme.spacing(15),
        display: 'grid',
        placeItems: 'center',
        margin: 'auto',
        maxWidth: '95%',
        padding: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4),
            width: '400px',
        },
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 24,
    },
    subtitle: {
        fontSize: 18,
    },
    pos: {
        marginBottom: 12,
    },
    flex: {
        padding: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column-reverse',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            gap: theme.spacing(2),
        },
    },
    btn: {
        textTransform: 'none',
        fontSize: '1rem',
        width: '100%',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(0),
        },
    },
}))

export const BookingSuccessful = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    return (
        <div className={classes.container}>
            <Card className={clsx(classes.root, classes.card)}>
                <CardContent className={classes.cardContent}>
                    <CheckCircleOutlineIcon style={{ fontSize: 50, color: green[500], marginBottom: 20 }} />
                    <Typography className={classes.title} color="textPrimary" variant="h3" component="h3" gutterBottom>
                        Booking successful!
                    </Typography>
                    <Typography
                        className={classes.subtitle}
                        color="textSecondary"
                        variant="body2"
                        component="h4"
                        gutterBottom
                    >
                        We will be reaching out to you soon.
                    </Typography>
                </CardContent>
                <div className={clsx(classes.flex)}>
                    <Button
                        className={classes.btn}
                        onClick={() => navigate('/')}
                        size="large"
                        color="primary"
                        variant="outlined"
                    >
                        My bookings
                    </Button>
                    <Button
                        className={classes.btn}
                        onClick={() => navigate('/create-booking')}
                        size="large"
                        color="primary"
                        variant="contained"
                    >
                        Book more workers
                    </Button>
                </div>
            </Card>
        </div>
    )
}
